import styled from "@emotion/styled";
import lupa from "../../img/buscar.png"

export const Info = styled.p`
    font-size: 1.5rem;
    color: white;
    font-weight: bold;
    padding: 1rem;
`;

export const ColumnGames = styled.div`
    display: grid;
    margin-top: 10px;
    grid-template-columns: repeat(4, 1fr);
    column-gap: 2rem;
    @media only screen and (max-width: 720px){
        grid-template-columns: 1fr;
        row-gap: 2rem;
    }
    /* border: 1px solid red;  */
`;
export const GameArticle = styled.article`
    padding: 1rem;
    background-color:#212529;
    /* border: 1px solid blue; */
    /* max-height: 30vh; */
    height: 360px;
    width: 300px;
    /* border: 5px solid yellow; */
    border-radius: 10px;
    -webkit-box-shadow: 10px 10px 5px 0px rgba(0,0,0,0.75);
    -moz-box-shadow: 10px 10px 5px 0px rgba(0,0,0,0.75);
    box-shadow: 10px 10px 5px 0px rgba(0,0,0,0.75);

`;  

export const Image = styled.img`
    width: 250px;
    height: 250px;
`;

export const TitleGame = styled.h2`
    font-size: 1.5rem;
    color: white;
    font-weight: bold;
    text-align: center;
`; 
export const ButtonUpdate = styled.button`
    font-size: 1rem;
    font-weight: bold;
    padding: 1rem;
    border: 0;
    border-radius: 6px;
    color: white;
    background-color: #00B74A;

    &:hover{
        cursor: pointer;
    }
`;
export const ButtonDelete = styled.button`
    padding: 1rem;
    border: 0;
    border-radius: 6px;
    color: white;
    background-color: red;

    &:hover{
        cursor: pointer;
    }
`;

export const Error = styled.p`
    font-size: 1.5rem;
    font-weight: bold;
    background-color:red;
    padding: 1rem;
    color: white;
    text-align: center;
    border-radius: 6px;
`;

export const InfoButton = styled.p`
    font-size: 1.5rem;
    font-weight: bold;
    background-color:#00B74A;
    padding: 1rem;
    color: white;
    text-align: center;
    border-radius: 6px;

`;

export const InputSearch = styled.input`
    border-radius: 6px;
    color: #1d2129;
    padding: 0.5rem 0;
    width: 240px;
    /* width: 23vw; */
    /* width: 50%; */
    /* width: 480px; */
    /* width: */
    border: 3px solid #DDDFE2;
    display: block;
    margin-left: 5px;

`;

export const SearchIcon = styled.div`
    /* background-image: bg-image("../../img/buscar.png"); */
    background-image: url(${lupa});
    background-repeat: no-repeat;
    background-size: 3.5rem;
    width: 50px;
    height: 50px;
    bottom: 85px;
    left: 190px;
    /* background-color:white; */
    position: absolute;
    /* bottom: 15px; */
    /* left: 445px; */
    /* background-color: red; */
    /* @media only screen and (max-width: 720px){
        left: 53vw;
    }
    @media only screen and (min-width: 720px){
        left: 165px;
    }

    @media only screen and (min-width: 992px){
        left: 410px;
    }
    @media only screen and (min-width: 1200px){
        left: 410px;
    }
    @media only screen and (min-width: 1600px){
        left: 410px;

    } */
`;